var map = {
	"./award.jpg": "a228",
	"./donation_certificate.jpg": "64be",
	"./gck01_trial.jpg": "47f2",
	"./news_expo.jpg": "fcde",
	"./news_expo2.jpg": "c3e5",
	"./news_gecell.jpg": "2e4d",
	"./news_mtb.jpg": "7f69",
	"./news_mtb2.jpg": "7c6d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "caec";